import request from '@/utils/request'

export const createCategory = function(data: any) {
  return request({
    url: '/categories',
    method: 'post',
    data
  })
}
